import { FormProvider as Form } from "react-hook-form"
export default function FormProvider({children, methods, onSubmit, style}){
    return (
        <Form {...methods}>
            <form onSubmit={onSubmit}>{children}</form>
        </Form>
    )
}